module.exports.getNotificationDayOptions = (phaseName) => {
    const returnData = [];
    try {
        let limit = 12;
        if (phaseName === "menstrual_phase") {
            limit = 12;
        } else if (phaseName === "follicular_phase") {
            limit = 11;
        } else if (phaseName === "ovulation_phase") {
            limit = 2;
        } else if (phaseName === "luteal_phase") {
            limit = 22;
        }
        for (let i = 1; i <= limit; i++) {
            returnData.push({
                label: i,
                value: i
            })
        }
    } catch { };
    return returnData;
};

module.exports.getPhaseOptions = (phaseName) => {
    const returnData = [
        {
            label: "Menstrual Phase",
            value: "menstrual_phase"
        },
        {
            label: "Follicular Phase",
            value: "follicular_phase"
        },
        {
            label: "Ovulation Phase",
            value: "ovulation_phase"
        },
        {
            label: "Luteal Phase",
            value: "luteal_phase"
        }
    ];
    return returnData;
}